"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectComponent = exports.Separator = exports.Option = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Menu = _interopRequireWildcard(require("../Menu"));

var _DropDown = _interopRequireWildcard(require("../DropDown"));

var _Input = require("../Input");

var _Spinner = _interopRequireDefault(require("../Spinner"));

var _dropDown = _interopRequireDefault(require("../icons/drop-down.svg"));

var _config = require("../config/config");

var _prepareInputName = _interopRequireDefault(require("../_utils/prepareInputName"));

var _withNamedError = _interopRequireDefault(require("../withNamedError"));

require("./select.sass");

var Option =
/*#__PURE__*/
function (_MenuItem) {
  (0, _inherits2.default)(Option, _MenuItem);

  function Option() {
    (0, _classCallCheck2.default)(this, Option);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(Option).apply(this, arguments));
  }

  (0, _createClass2.default)(Option, [{
    key: "render",
    value: function render() {
      var props = (0, _objectSpread2.default)({}, this.props, {
        children: this.props.children || this.props.label
      });
      return _react.default.createElement(_Menu.MenuItem, (0, _extends2.default)({
        className: "menu-item--option"
      }, props));
    }
  }]);
  return Option;
}(_Menu.MenuItem);

exports.Option = Option;
(0, _defineProperty2.default)(Option, "propTypes", {
  disabled: _propTypes.default.bool,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  value: _propTypes.default.any
});

var _ref2 = _react.default.createElement(_Menu.MenuDelimiter, null);

var Separator = function Separator(_ref) {
  var label = _ref.label;

  if (label) {
    return _react.default.createElement(_Menu.MenuHeader, null, label);
  }

  return _ref2;
};

exports.Separator = Separator;

var _ref5 = _react.default.createElement(_Spinner.default, null);

var SelectComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(SelectComponent, _React$PureComponent);

  function SelectComponent() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SelectComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SelectComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "align", _DropDown.ALIGN_LEFT | _DropDown.ALIGN_TOP | _DropDown.ALIGN_WIDTH);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "controlled", _this.props.hasOwnProperty('value'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      value: _this.props.defaultValue,
      input: _this.props.defaultLabel
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "set", function (e, value) {
      var label = _this.getLabelByValue(value) || value;
      _this.props.onChange && _this.props.onChange(e, value, label);
      _this.hidden && _this.hidden.dispatchEvent(new Event('input', {
        bubbles: true
      }));

      if (!_this.controlled) {
        _this.setState({
          value: value,
          input: label
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleChange", function () {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleInputRef", function (element) {
      return _this.input = element;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleHiddenRef", function (element) {
      return _this.hidden = element;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleDropDownRef", function (element) {
      return _this.dropDown = element;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleDropDownShow", function () {
      _this.setState({
        focus: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleDropDownHide", function () {
      _this.setState({
        focus: false
      });

      _this.input && _this.input.blur();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleFocus", function (e) {
      _this.props.onFocus && _this.props.onFocus(e);
      _this.dropDown && _this.dropDown.show();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleBlur", function (e) {
      _this.props.onBlur && _this.props.onBlur(e);
      _this.dropDown && _this.dropDown.hide();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleMenuMouseDown", function (e) {
      // prevent blur event to be fired
      e.preventDefault();
    });
    return _this;
  }

  (0, _createClass2.default)(SelectComponent, [{
    key: "getLabelByValue",
    value: function getLabelByValue(value) {
      var _this$props = this.props,
          children = _this$props.children,
          defaultValue = _this$props.defaultValue,
          defaultLabel = _this$props.defaultLabel;

      var item = _react.default.Children.toArray(children).find(function (_ref3) {
        var props = _ref3.props;
        return props && props.hasOwnProperty('label') && props.value === value;
      });

      if (item && item.props.label) {
        return item.props.label;
      }

      if (value === defaultValue && defaultLabel) {
        return defaultLabel;
      }

      return value;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var _ref4 = this.controlled ? this.props : this.state,
          value = _ref4.value;

      if (value || value === '0' || value === 0) {
        return value;
      }

      return '';
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this.getLabelByValue(this.getValue());
    }
  }, {
    key: "getOptionalMessage",
    value: function getOptionalMessage() {
      var _this$props2 = this.props,
          optional = _this$props2.optional,
          emptyLabel = _this$props2.emptyLabel;

      if (optional === true) {
        return emptyLabel || (0, _config.__)('Empty');
      }

      return optional || null;
    }
  }, {
    key: "getChildrenArray",
    value: function getChildrenArray() {
      var children = _react.default.Children.toArray(this.props.children);

      if (this.props.optional) {
        children.unshift(_react.default.createElement(Option, {
          key: "",
          label: "",
          onClick: this.set
        }, _react.default.createElement("span", {
          className: "empty"
        }, this.getOptionalMessage())));
      }

      return children;
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      if (this.props.isLoading) {
        return _ref5;
      }

      return this.getChildrenArray().filter(function (element) {
        return !!element;
      }).map(function (element) {
        return _react.default.cloneElement(element, {
          onClick: function onClick(e) {
            _this2.set(e, element.props.hasOwnProperty('value') ? element.props.value : element.props.label);
          }
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          name = _this$props3.name,
          align = _this$props3.align,
          onIconClick = _this$props3.onIconClick,
          readOnly = _this$props3.readOnly,
          label = _this$props3.label,
          placeholder = _this$props3.placeholder,
          error = _this$props3.error,
          disabled = _this$props3.disabled;

      var input = _react.default.createElement("div", null, _react.default.createElement(_Input.InputComponent, {
        disabled: disabled,
        Icon: _dropDown.default,
        ref: this.handleInputRef,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onIconClick: onIconClick,
        readOnly: readOnly,
        label: label,
        error: error,
        placeholder: label ? null : placeholder || this.getOptionalMessage(),
        hasFocus: this.state.focus,
        value: this.getLabel(),
        autoComplete: this.autocomplete
      }), name && _react.default.createElement("input", {
        ref: this.handleHiddenRef,
        type: "hidden",
        value: this.getValue(),
        name: (0, _prepareInputName.default)(name)
      }));

      return _react.default.createElement(_DropDown.default, {
        className: "form-field",
        ref: this.handleDropDownRef,
        trigger: input,
        align: align || this.align,
        onShow: this.handleDropDownShow,
        onHide: this.handleDropDownHide
      }, !disabled && _react.default.createElement(_Menu.default, {
        scope: "input",
        onMouseDown: this.handleMenuMouseDown
      }, this.renderItems()));
    }
  }, {
    key: "autocomplete",
    get: function get() {
      var isAutocompleteOff = this.props.isAutocompleteOff;
      return isAutocompleteOff ? 'new-password' : 'on';
    }
  }]);
  return SelectComponent;
}(_react.default.PureComponent);

exports.SelectComponent = SelectComponent;
(0, _defineProperty2.default)(SelectComponent, "defaultProps", {
  isAutocompleteOff: true
});
SelectComponent.propTypes = process.env.NODE_ENV !== "production" ? (0, _objectSpread2.default)({}, _Input.InputComponent.propTypes, {
  optional: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  defaultLabel: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
  isLoading: _propTypes.default.bool,
  emptyLabel: _propTypes.default.string,
  isAutocompleteOff: _propTypes.default.bool
}) : {};

var _default = (0, _withNamedError.default)(SelectComponent);

exports.default = _default;